"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = DisconnectedIcon;

var _react = _interopRequireDefault(require("react"));

var _Icon = _interopRequireDefault(require("./Icon"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function DisconnectedIcon(props) {
  return /*#__PURE__*/_react.default.createElement(_Icon.default, props, /*#__PURE__*/_react.default.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.8744 8.00149C14.4309 6.27547 12.8644 4.99994 11 4.99994C8.79086 4.99994 7 6.7908 7 8.99994C7 9.37795 7.05243 9.74371 7.15043 10.0903C5.34939 10.4799 4 12.0823 4 13.9999C4 16.2091 5.79086 17.9999 8 17.9999H13.0059C13.1364 15.2166 15.4343 13 18.25 13C18.8604 13 19.4465 13.1042 19.9914 13.2957C19.9971 13.1978 20 13.0992 20 12.9999C20 10.2385 17.7614 7.99994 15 7.99994C14.958 7.99994 14.9161 8.00046 14.8744 8.00149ZM15.7071 15.7929C16.0976 15.4024 16.7308 15.4024 17.1213 15.7929L18.185 16.8566L19.2486 15.7929C19.6392 15.4024 20.2723 15.4024 20.6629 15.7929C21.0534 16.1834 21.0534 16.8166 20.6629 17.2071L19.5992 18.2708L20.6568 19.3284C21.0473 19.719 21.0473 20.3521 20.6568 20.7426C20.2663 21.1332 19.6331 21.1332 19.2426 20.7426L18.185 19.685L17.1273 20.7426C16.7368 21.1332 16.1036 21.1332 15.7131 20.7426C15.3226 20.3521 15.3226 19.719 15.7131 19.3284L16.7708 18.2708L15.7071 17.2071C15.3166 16.8166 15.3166 16.1834 15.7071 15.7929Z"
  }));
}